export default class TripAdvisorRating {
  static fromJSON(json) {
    return new TripAdvisorRating({
      bubbleRating: json.bubbleRating || 0,
      reviewCount: json.reviewCount || 0
    })
  }

  constructor({ bubbleRating, reviewCount }) {
    this.bubbleRating = bubbleRating
    this.reviewCount = reviewCount
  }
}
